//@flow
export const getToolTipMessage = (category: string, action: string) => {
  if (action === 'extension') {
    return `We love that you love your ${category}! You're welcome to extend your booking for as long as it's available.`;
  }
  return `If your ${category} is just not cutting it, swap it!`;
};
